import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetCampaignsQuery } from '../redux/apis/campaignsManagement/campaigns/cMCampaignsApiSlice'

const CampaignDropdown = ({
  onChange,
  onBlur,
  value,
  className = '',
  customer_id = null,
  service_id = null,
  isAll= false,
  mode,
  status
}) => {
  const { data, isLoading, error } = useGetCampaignsQuery({
    page: '*',
    fields: ['id', 'campaign_name'].join(','),
    ...(customer_id ? { customer: customer_id } : {}),
    ...(service_id ? { service_id } : {}),
    ...(status ? { status } : {}),
  })

  useEffect(() => {
    if (!error && !isLoading) {
      return
    }
    toast.error(error)
  }, [error, isLoading])

  const allSelected = Array.isArray(value) ? value.includes('*') : value === '*'

  let options

  if (data) {
      options = data?.data?.results?.map(x => {
          return {
            label: x.campaign_name,
            value: x.id,
            disabled: allSelected
          }
      })
      if (isAll) {
          options = [{ label: "All Campaigns", value: "*" }, ...options]
      }

  }

  return (
    <div className=' mb-3'>
      <Loader isLoading={isLoading} />
      <label className="form-label">Campaign</label>
      <br />
      <Select
        name='campaign'
        className={className}
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={options}
        mode={mode}
      />
    </div>
  )
}

export default CampaignDropdown
